import styled, { css } from "styled-components";
import { getColor, getSize, responsive } from "~/spocketUI/helpers/style";
import { UIProps } from "~/spocketUI/types/style";

interface IPlanCard extends UIProps {
  primary: boolean;
}

interface IIsHighlighted extends UIProps {
  isHighlighted?: boolean;
}

export const PlanCardContainer = styled.div<IPlanCard>`
  padding: ${getSize(3.7)} ${getSize(2)};
  align-items: baseline;
  position: relative;
  flex: 1;
  min-width: 239px;
  max-width: 270px;
  min-height: 634px;
  height: auto;
  border: 1px solid ${getColor("disabled")};
  border-radius: ${getSize(1.1)};

  .separator {
    background-color: ${getColor("disabled")};
  }

  ${({ primary }) =>
    primary &&
    css`
      background-color: ${getColor("primary")};
      border: 0 solid ${getColor("primary")};
      color: ${getColor("white")};
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    `}
`;

export const ImageContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

interface IPlanCardPromotion extends UIProps {
  isHighlighted: boolean;
}

export const PlanCardPromotion = styled.div<IPlanCardPromotion>`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  left: 0;
  border-radius: 7px 7px 0 0;
  font-weight: 500;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${getColor("white")}20;
      color: ${getColor("white")};
    `}
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: ${getSize(0.7)};
`;

export const ButtonContainer = styled.div<IIsHighlighted>`
  text-align: center;
  padding-top: ${getSize(1.6)};

  button {
    border: 2px solid ${getColor("primary")};
    ${({ isHighlighted }) =>
      isHighlighted &&
      css`
        border: 2px solid ${getColor("white")};
      `}
  }
`;

export const PlanCardTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.005em;
  margin: 0;
  position: relative;
`;

export const PlanCardSubtitle = styled.h3<IIsHighlighted>`
  font-size: 15px;
  font-weight: 400;
  line-height: 22.89px;
  margin: ${getSize(0.5)} 0 ${getSize(1)} 0;
  position: relative;
  color: ${getColor("textDisabled")};
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      color: ${getColor("white")};
    `}
`;

export const PlanBilledAnnualText = styled.h3<IIsHighlighted>`
  font-size: 13px;
  font-weight: 500;
  line-height: 15.73px;
  letter-spacing: 0.0025em;
  padding: 4px 10px 4px 10px;
  margin: ${getSize(0.5)} 0 ${getSize(1)} 0;
  border-radius: 2px;

  color: ${getColor("primary")};
  background-color: ${getColor("primary")}15;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      color: ${getColor("white")};
      background-color: ${getColor("white")}15;
    `}
`;

export const PlanCardPrice = styled.h3`
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.0025em;
  position: relative;
  display: flex;
  margin: 0;
  align-items: center;
`;

export const MostPopularText = styled.span`
  color: ${getColor("white")};
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 3px;
`;

export const MonthsOffText = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 18.31px;
`;

export const DiscountText = styled.span`
  width: max-content;
  color: ${({ color }) => getColor(color)};
  opacity: 0.5;
  font-size: 20px;
  font-weight: 400;
  line-height: 24.2px;
  letter-spacing: 0.0025em;
  text-decoration: line-through;
  margin-right: ${getSize(0.6)};
`;

export const MonthlyValue = styled.span<IIsHighlighted>`
  font-size: 13px;
  font-weight: 400;
  line-height: 15.73px;
  margin-left: ${getSize(0.5)};

  color: ${getColor("textDisabled")};
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      color: ${getColor("white")};
    `}
`;

export const DecimalValue = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

export const PlanCardList = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${getSize(1.6)};
  gap: ${getSize(1.6)};
  margin-top: ${getSize(2)};
`;

export const PlanCardItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${getSize(1.2)};
`;

export const FeatureText = styled.div`
  font-size: 13px;
  width: calc(100% - ${getSize(3.6)});
`;

export const EverythingPLusText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 21.36px;
`;
